// Cart Drawer Fix - Opens drawer and updates cart after adding products
// This does NOT intercept anything, just listens for successful cart additions

(function() {
  'use strict';
  
  // Save original fetch
  const originalFetch = window.fetch;
  
  window.fetch = function(...args) {
    const url = args[0];
    const options = args[1] || {};
    
    // Check if this is a cart add request
    const isCartAdd = typeof url === 'string' && 
                      (url.includes('/cart/add.js') || url.includes('/cart/add'));
    
    if (isCartAdd && options.method !== 'GET') {
      // Call original fetch
      return originalFetch.apply(this, args)
        .then(response => {
          // If successful, update cart UI
          if (response.ok) {
            updateCartUI();
          }
          
          // Return original response for theme's code to handle
          return response;
        });
    }
    
    // Not a cart add, just pass through
    return originalFetch.apply(this, args);
  };
  
  function updateCartUI() {
    // Wait a bit longer to ensure Shopify has processed the cart update
    setTimeout(() => {
      updateCartIcon()
        .then(() => openAndRefreshCartDrawer())
        .catch(() => {});
    }, 300);
  }
  
  function updateCartIcon() {
    return fetch('/cart?section_id=cart-icon-bubble')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartIcon = doc.querySelector('.shopify-section');
        const currentCartIcon = document.getElementById('cart-icon-bubble');
        
        if (newCartIcon && currentCartIcon) {
          currentCartIcon.innerHTML = newCartIcon.innerHTML;
        }
      });
  }
  
  function openAndRefreshCartDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (!cartDrawer) {
      return Promise.resolve();
    }
    
    // Fetch updated cart drawer content
    return fetch('/cart?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');
        
        if (!newCartDrawer) return;
        
        // Copy the inner HTML completely
        const cartDrawerInner = cartDrawer.querySelector('.cart-drawer');
        const newCartDrawerInner = newCartDrawer.querySelector('.cart-drawer');
        
        if (cartDrawerInner && newCartDrawerInner) {
          cartDrawerInner.innerHTML = newCartDrawerInner.innerHTML;
        }
        
        // Update the class on the cart-drawer element itself
        if (!newCartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.remove('is-empty');
        }
        
        // Open the drawer
        if (typeof cartDrawer.open === 'function') {
          cartDrawer.open();
        } else {
          cartDrawer.classList.add('active');
        }
      });
  }
  
  // Quantity change listener - updates drawer prices when quantity changes
  function initQuantityChangeListener() {
    document.addEventListener('change', function(e) {
      const target = e.target;
      
      // Check if this is a quantity input in the cart drawer
      if (target.classList.contains('quantity__input') && target.closest('cart-drawer-items')) {
        // Wait longer to ensure the API call has completed
        setTimeout(() => {
          refreshCartDrawerOnly();
        }, 800);
      }
    });
  }
  
  function refreshCartDrawerOnly() {
    const cartDrawer = document.querySelector('cart-drawer');
    
    if (!cartDrawer) return;
    
    // Update cart icon
    fetch('/cart?section_id=cart-icon-bubble')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartIcon = doc.querySelector('.shopify-section');
        const currentCartIcon = document.getElementById('cart-icon-bubble');
        
        if (newCartIcon && currentCartIcon) {
          currentCartIcon.innerHTML = newCartIcon.innerHTML;
        }
      });
    
    // Update drawer content
    fetch('/cart?section_id=cart-drawer')
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newCartDrawer = doc.querySelector('cart-drawer');
        
        if (!newCartDrawer) return;
        
        // Update drawer content
        const cartDrawerInner = cartDrawer.querySelector('.cart-drawer');
        const newCartDrawerInner = newCartDrawer.querySelector('.cart-drawer');
        
        if (cartDrawerInner && newCartDrawerInner) {
          cartDrawerInner.innerHTML = newCartDrawerInner.innerHTML;
        }
        
        // Update is-empty class
        if (newCartDrawer.classList.contains('is-empty')) {
          cartDrawer.classList.add('is-empty');
        } else {
          cartDrawer.classList.remove('is-empty');
        }
      });
  }
  
  // Initialize quantity change listener
  initQuantityChangeListener();
  
  // Close drawer when clicking outside (on overlay)
  function initCloseOnClickOutside() {
    document.addEventListener('click', function(e) {
      const cartDrawer = document.querySelector('cart-drawer');
      
      if (!cartDrawer) return;
      if (!cartDrawer.classList.contains('active')) return;
      
      const drawerInner = cartDrawer.querySelector('.drawer__inner');
      const overlay = cartDrawer.querySelector('.cart-drawer__overlay, #CartDrawer-Overlay');
      
      if (e.target === overlay || (e.target === cartDrawer && !drawerInner.contains(e.target))) {
        if (typeof cartDrawer.close === 'function') {
          cartDrawer.close();
        } else {
          cartDrawer.classList.remove('active');
        }
      }
    });
  }
  
  initCloseOnClickOutside();
})();

